import type { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { Input } from "../../elements/input/input";
import { Label } from "../../elements/label/label";
import { Text } from "../../elements/text/text";

export interface UserFormFieldProps {
  id: string;
  label: string;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  registerProps?: UseFormRegisterReturn;
  error?: FieldError;
  className?: string;
  placeholder?: string;
  children?: React.ReactNode;
  labelClassName?: string;
  autoComplete?: string;
}

export function UserFormField({
  id,
  label,
  type = "text",
  required = false,
  disabled = false,
  registerProps,
  error,
  className = "flex flex-col gap-2",
  placeholder,
  children,
  labelClassName,
  autoComplete,
}: Readonly<UserFormFieldProps>) {
  return (
    <div className={className}>
      <Label className={labelClassName} htmlFor={id}>
        {label}
        {required && "*"}
      </Label>
      <Input
        aria-describedby={error ? `${id}-error` : undefined}
        aria-invalid={error ? true : undefined}
        aria-required={required}
        autoComplete={autoComplete}
        disabled={disabled}
        id={id}
        placeholder={placeholder}
        type={type}
        variant={error ? "error" : "default"}
        {...registerProps}
      />
      {children ||
        (error && (
          <Text color="red" id={`${id}-error`} variant="body-xs">
            {error.message}
          </Text>
        ))}
    </div>
  );
}
